import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import API from 'core/Api';
import { useQueryClient } from 'react-query';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity } from 'utils/helpers/client';
import { formatBytes } from 'utils/helpers/formatters';
import TooltipWrapper from 'components/TooltipWrapper';
import { FaTrash } from 'react-icons/fa';
import styled from 'styled-components';
import Button from 'components/Button';

interface IFile {
  id: number;
  name: string;
  size: number;
}

interface IProps {
  files: IFile[];
}

const StepThree: FC<IProps> = ({ files }: IProps) => {
  const queryClient = useQueryClient();
  const { client } = useActiveClientContext();
  const { t } = useTranslation();

  const removeFile = (id: number) => {
    API.delete(`document-wizard/external-documents/${id}`).then(() => {
      queryClient.invalidateQueries(buildClientEntity('step-three', client));
    });
  };

  return (
    <>
      <h4 className="text-center mb-4">{t('common.currentlyUploadedFiles')}</h4>
      <ul>
        {files.map((file: IFile) => (
          <li>
            <FlexWrapper className="mb-2">
              <div>
                <span className="d-inline-block font-weight-bold">{file.name}</span>
                <span className="d-inline-block">&nbsp;-&nbsp;</span>
                <span className="d-inline-block">{formatBytes(file.size)}</span>
              </div>
              <div className="d-inline-block">
                <TooltipWrapper
                  id="tooltip-trash"
                  overlay="Изтрий"
                >
                  <Button
                    btnType="danger"
                    size="sm"
                    outlined
                    onClick={() => removeFile(file.id)}
                  >
                    <FaTrash size={14} />
                  </Button>
                </TooltipWrapper>
              </div>
            </FlexWrapper>
          </li>
        ))}
      </ul>
    </>
  );
};

const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default StepThree;
